import activemonitoringIcon from 'assets/images/icons_monitoring.png';
import monitoringIcon from 'assets/images/grayicons_monitoring.png';
import activechartanalyticsIcon from 'assets/images/icons_chartanalytics.png';
import chartanalyticsIcon from 'assets/images/grayicons_chartanalytics.png';
import activeforecastIcon from 'assets/images/icons_forecast.png';
import forecastIcon from 'assets/images/grayicons_forecast.png';
import activemanagerIcon from 'assets/images/hugeicons_manager.png';
import managerIcon from 'assets/images/grayhugeicons_manager.png';
import managerImg from 'assets/images/manager.png';
import monitoringImg from 'assets/images/monitoring.png';
import analysisImg from 'assets/images/analysis.png';
import forecastImg from 'assets/images/forecast.png';

export const DEFAULT_TAB = '1';

export const ROUTES = {
  MONITORING: '/monitoring/dashboard',
  ANALYSIS: '/analysis/dashboard',
  FORECAST: '/forecast/dashboard',
  MANAGER: '/dashboards/home',
};

export const TAB_CONFIG = {
  1: {
    id: '1',
    title: 'Monitoring',
    requiredRole: 'monitoring',
    icon: monitoringIcon,
    activeIcon: activemonitoringIcon,
    route: import.meta.env.VITE_REACT_MONITORING_ROUTE,
    image: monitoringImg,
    imageAlt: 'monitoring capture',
    description:
      'Monitor all your critical sensors and devices in real time. Instantly detect anomalies, receive alerts, and review historical trends for operational awareness.',
    features: [
      'Live sensor and device dashboards',
      'Instant alerts for threshold breaches',
      'Detailed historical data access',
      'Compare multiple locations or devices',
    ],
  },
  2: {
    id: '2',
    title: 'Analysis',
    requiredRole: 'analysis',
    icon: chartanalyticsIcon,
    activeIcon: activechartanalyticsIcon,
    route: import.meta.env.VITE_REACT_ANALYSIS_ROUTE,
    image: analysisImg,
    imageAlt: 'analysis capture',
    description: 'Explore and analyze your collected data with advanced tools. Visualize trends, apply filters, and generate actionable insights for better decision-making.',
    features: [
      'Interactive data visualizations',
      'Advanced filtering and segmentation',
      'Aggregated and comparative analytics',
      'Export charts and reports',
    ],
  },
  3: {
    id: '3',
    title: 'Industrial',
    requiredRole: 'industrial',
    icon: forecastIcon,
    activeIcon: activeforecastIcon,
    route: import.meta.env.VITE_REACT_INDUSTRIALS_ROUTE,
    image: forecastImg,
    imageAlt: 'industrial capture',
    description: 'Industrial-grade air quality oversight for your sites. Track emissions, regulatory thresholds, and operational impact in one place.',
    features: [
      'Site and stack monitoring',
      'Regulatory threshold tracking',
      'Industrial alerting and reporting',
      'Plant-wide air quality overview',
    ],
  },
  4: {
    id: '4',
    title: 'Manager',
    requiredRole: 'manager',
    icon: managerIcon,
    activeIcon: activemanagerIcon,
    route: import.meta.env.VITE_REACT_MANAGER_ROUTE,
    image: managerImg,
    imageAlt: 'manager capture',
    description: 'Administer your organization, users, and system preferences. Configure access, roles, and platform-wide settings for a secure and tailored experience.',
    features: [
      'Comprehensive user and team management',
      'Role-based access and permissions',
      'Customizable platform settings',
      'Audit logs and system health monitoring',
    ],
  },
};
